var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypalIntable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal_intable",
    transform: "translate(-399.531 -1005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayPal",
    transform: "translate(413.531 1005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46336",
    "data-name": "Path 46336",
    d: "M5.913,23.386l.409-2.641-.911-.021H1.061L4.084,1.237a.259.259,0,0,1,.084-.153.244.244,0,0,1,.161-.06h7.335c2.435,0,4.116.515,4.993,1.532a3.512,3.512,0,0,1,.8,1.524,5.592,5.592,0,0,1,.005,2.1l-.009.061V6.78l.411.237a2.891,2.891,0,0,1,.833.646A3.029,3.029,0,0,1,19.373,9.2a6.623,6.623,0,0,1-.1,2.235,7.956,7.956,0,0,1-.9,2.53,5.174,5.174,0,0,1-1.427,1.59,5.745,5.745,0,0,1-1.922.882,9.436,9.436,0,0,1-2.4.282h-.571a1.714,1.714,0,0,0-1.116.417,1.764,1.764,0,0,0-.582,1.056l-.043.238-.723,4.655-.033.171a.148.148,0,0,1-.045.1.12.12,0,0,1-.075.028H5.913Z",
    transform: "translate(-0.231 -0.205)",
    fill: "#253b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46337",
    "data-name": "Path 46337",
    d: "M19.372,7.667h0q-.033.215-.075.44c-.967,5.081-4.277,6.836-8.5,6.836H8.642a1.053,1.053,0,0,0-1.033.906h0L6.507,23,6.2,25.024a.559.559,0,0,0,.543.651h3.817a.925.925,0,0,0,.907-.792l.038-.2.719-4.666.046-.256a.925.925,0,0,1,.907-.794h.571c3.7,0,6.593-1.536,7.439-5.981.353-1.857.17-3.407-.765-4.5A3.661,3.661,0,0,0,19.372,7.667Z",
    transform: "translate(-1.349 -1.676)",
    fill: "#179bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46338",
    "data-name": "Path 46338",
    d: "M18.756,7.062Q18.535,7,18.3,6.942t-.484-.094a11.687,11.687,0,0,0-1.9-.142H10.169a.9.9,0,0,0-.4.092.936.936,0,0,0-.51.7L8.04,15.426,8,15.657a1.053,1.053,0,0,1,1.033-.906H11.19c4.227,0,7.536-1.756,8.5-6.836.029-.15.053-.3.075-.44a5.094,5.094,0,0,0-.8-.343C18.9,7.108,18.83,7.085,18.756,7.062Z",
    transform: "translate(-1.745 -1.392)",
    fill: "#222d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46339",
    "data-name": "Path 46339",
    d: "M7.518,6.119a.927.927,0,0,1,.51-.7.9.9,0,0,1,.4-.091h5.749a11.764,11.764,0,0,1,1.9.141q.249.041.484.093t.457.119l.217.068a5.189,5.189,0,0,1,.8.341,4.824,4.824,0,0,0-.995-4.285C15.935.542,13.961,0,11.434,0H4.1A1.054,1.054,0,0,0,3.063.9L.008,20.582a.637.637,0,0,0,.622.741H5.158l1.137-7.331Z",
    transform: "translate(0)",
    fill: "#253b80"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12265",
    "data-name": "Rectangle 12265",
    width: 48,
    height: 24,
    transform: "translate(399.531 1005)",
    fill: "#fff",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIntable);
export default __webpack_public_path__ + "static/media/paypal_intable.0d750563e8912351cbbf4b3c593f5280.svg";
export { ForwardRef as ReactComponent };